import React from 'react';
import './style.css'
import { Link } from 'react-router-dom';
import ChangeLang from '../../../components/changeLang'
import QRCode from "react-qr-code";
import { useTranslation } from 'react-i18next';

const Index = ({ showBack = false, showFooterBack = true, children, showLogo=true, showRedes=true, setShowListProduct }) => {
   
  const [showModal, setShowModal] = React.useState(false);
  const [showBoost, setshowBoost] = React.useState(false);
  const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;


  const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }

    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
        marginTop: 10,
        background: '#000'
      }}>
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >

            <div className='nav-menu-bar' style={{
              marginTop: -4 ,
              width: '100%',
              position: 'relative',
             
            
            }}>
               
              {showLogo &&
                
                <div
                  
                  style={{
              background: 'black',
                    paddingTop: 10,
              height: 100,
              
              
              width: '100%',
              display: 'flex',
              alignItems: 'center',
                    justifyContent: 'space-between',
                    position: 'relative',
                zIndex: 999
            
                }}>
                  {showBack ? 
                    <div
                      onClick={() => {
                        if (setShowListProduct) {
                          setShowListProduct()
                        }
                      }}
                      style={{
                        zIndex: 999,
                         display: 'flex',
                        alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                    
                    <img
                    style={{
                      width: 200,
                      
                  }}
                  src={require('./assets/back.png')}
                  alt="Logo"
                      /> 
                      <p style={{ color: 'white', position: 'absolute', fontWeight: '900', fontSize: 25 }}>{ langEng ? 'Go Back': 'Volver'}</p>
                  </div> : 
                  <div style={{
                        zIndex: 999
                    }}>
                    
                    <img
                    style={{
                          width: 100,
                      objectFit: 'cover'
                      
                  }}
                  src={require('./assets/logo.png')}
                  alt="Logo"
                  /> 
                  </div>
                  }
                    
                  
                  <div style={{ display: 'flex',
                      alignItems: 'center',
                          position: 'relative',
                          zIndex: 999,
                          justifyContent: 'space-between',}}>
                    <div onClick={()=>setShowModal('https://www.instagram.com/latinbistrorestaurantbakery?igsh=MXZmYjNvNGV4eXJ2YQ%3D%3D&utm_source=qr')} target='_blank'> <img
                    style={{
                      width: 28,
                        height: 28,
                        marginInline: 10
                    
                  }}
                  src={require('./assets/instagram.png')}
                  alt="Logo"
                  /> 
                  </div>

                  <div target='_blank' onClick={()=>setShowModal('https://www.facebook.com/share/1PNZ9oUwJ9/?mibextid=wwXIfr')}> 
                    
                    
                  <img
                    style={{
                        width: 28,
                          height: 28,
                          marginInline: 10
                  }}
                  src={require('./assets/facebook.png')}
                  alt="Logo"
                  /> 
                        </div>
                         <ChangeLang/>
              
                <div>
                
                </div>
              </div>
              
              </div>
              }
              


            

            </div>
            {children}


            <div
            style={{
              position: 'absolute',
              bottom: 0,
                  alignSelf: 'center',
                
                  width: '100%',
                  left: 0,
                zIndex: 999,
                  backgroundColor: 'black'
                
              
              }}>
              <div
              style={{
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                paddingVertical: 5,
                  alignItems: 'center',
                marginTop: 20,
              }}>
                  <div
                   onClick={()=> setshowBoost(true)}
                style={{flexDirection: 'row', alignItems: 'center'}}>
                <p
                  style={{
                      color: '#fff',
                      fontWeight: '300',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
                 Powered by boostyourmenu.com V1.1
                </p>
              </div>
            </div>
            </div>



             {showBoost &&
              <div onClick={ ()=> setshowBoost(false)} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                <img
                 
                            style={{
                              width: 500,
                                height: 500,
                                marginInline: 10,
                                objectFit: 'contain',
                                zIndex: 9999
                            
                          }}
                          src={require('./assets/boost.png')}
                          alt="Logo"
                /> 
            
            </div>
            }


            {showModalPincode &&
              <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                
                <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                  <img
                      onClick={()=>setShowModalPincode(false)}
                    style={{
                      position: 'absolute',
                      top: -10,
                      
                                width: 40,
                                  height: 40,
                                  marginInline: 10,
                                  objectFit: 'contain',
                                  position: 'absolute',
                                  right: -10,
                                  zIndex: 9999
                              
                            }}
                      src={require('./assets/close.png')}
                      alt="Logo"
                  /> 
                  <h4 style={{ color: '#F40000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                  <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                    setScret(e.target.value)
                  }} />
                  <br /><br />
                  
                  <div style={{display: 'flex', gap: 20}}>
                    <div onClick={() => setShowModalPincode(false)} style={{background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                    </div>
                    <div onClick={()=>validScret()} style={{ background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                  </div>
                </div>
                </div>
              </div>
            }


            <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 30,
                            height: 30,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 
            

            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              viewBox={`0 0 256 256`}
            />
            </div>}
           
          </div>
        </div>
      </div>
     
    );
  };

export default Index;